import placeholder from "@/ui/common/assets/chain-placeholder.svg";

export function getBsnLogoUrl(bsnId?: string): string {
  if (!bsnId) return placeholder;
  return placeholder;
}
